// src/socket.js
import { io } from "socket.io-client";
import { SOCKET_URL } from "./config";

const isProduction = process.env.NODE_ENV === "production";

const socket = io(SOCKET_URL, {
  path: "/socket.io",
  transports: isProduction ? ["websocket"] : ["polling", "websocket"], // ✅ prod = WS only
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

export default socket;
